"use strict";
var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InsurerController = void 0;
const tslib_1 = require("tslib");
const common_1 = require("@nestjs/common");
const constants_1 = require("../../../../../../libs/service-lib/src/lib/constants");
const enum_1 = require("../../../../../../libs/service-lib/src/lib/enum");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
const response_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/response.utils");
const create_insurer_dto_1 = require("./dto/create-insurer.dto");
const get_all_insurers_dto_1 = require("./dto/get-all-insurers.dto");
const update_insurer_dto_1 = require("./dto/update-insurer.dto");
const insurer_service_1 = require("./insurer.service");
const insurer_swagger_1 = require("./insurer.swagger");
const scope_utils_1 = require("../../../../../../libs/service-lib/src/lib/utils/scope.utils");
let InsurerController = class InsurerController {
    constructor(insurerService, scopeService) {
        this.insurerService = insurerService;
        this.scopeService = scopeService;
    }
    /** Add a new insurer. */
    async addInsurer(req, res, createInsurerDto) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const insurer = await this.insurerService.addInsurer(createInsurerDto, userId);
            return res
                .status(enum_1.statusCode.ok)
                .json((0, response_utils_1.createResponse)(enum_1.statusCode.ok, messages_1.successMessage.insurerCreated, insurer));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.insurerNotFound, messages_1.errorMessages.insurerCreationForbidden, messages_1.errorMessages.unknownError);
        }
    }
    /** Get all insurers. */
    async getAllInsurers(getAllInsurersDto, res, req) {
        try {
            const { page, limit, sort, search, searchBy } = getAllInsurersDto;
            const userId = parseInt(req?.headers?.userid);
            const result = await this.insurerService.getAllInsurers(page ?? constants_1.DEFAULT_PAGE, limit ?? constants_1.DEFAULT_LIMIT, sort ?? constants_1.DEFAULT_SORT_FIELD, search, searchBy, userId);
            const mappedResult = {
                data: result.insurers,
                count: result.total,
                totalActiveInsurers: result.totalActiveInsurers,
                totalActivePolicies: result.totalActivePolicies,
            };
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.insurerListRetrieved, mappedResult));
        }
        catch (error) {
            return res
                .status(enum_1.statusCode.badRequest)
                .json((0, response_utils_1.createErrorResponse)(enum_1.statusCode.badRequest, messages_1.errorMessages.failedToFetchInsurers || error.message));
        }
    }
    /** Get a list of insurers. */
    async getInsurerList(query, res, req) {
        try {
            const { page, limit, search, sortBy, sortOrder } = query;
            const userId = parseInt(req?.headers?.userid);
            const insurerList = await this.insurerService.getInsurerList(page || constants_1.DEFAULT_PAGE, limit || constants_1.DEFAULT_LIMIT, search || "", sortBy || constants_1.DEFAULT_SORT_FIELD, sortOrder || constants_1.DEFAULT_SORT_ORDER, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.insurerListRetrieved, insurerList));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.BAD_REQUEST)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error.message || messages_1.errorMessages.failedToFetchInsurers));
        }
    }
    /** Get details of a single insurer by ID. */
    async getInsurerDetails(id, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const insurerDetails = await this.insurerService.getInsurerDetails(id, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.insurerDetailsRetrieved, insurerDetails));
        }
        catch (error) {
            return res
                .status(common_1.HttpStatus.NOT_FOUND)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message || messages_1.errorMessages.insurerNotFound));
        }
    }
    /** Get a single insurer by ID. */
    async getInsurerById(insurerId, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const viewValidation = await this.scopeService.validateResourceScope(userId, 'insurer', 'view', insurerId);
            if (!viewValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to view this company."));
            }
            const editValidation = await this.scopeService.validateResourceScope(userId, 'insurer', 'edit', insurerId);
            const insurer = await this.insurerService.getInsurerById(insurerId);
            const response = { ...insurer, editable: editValidation };
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.insurerDetails, response));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.insurerNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.unknownError);
        }
    }
    /** Modify an existing insurer. */
    async modifyInsurer(req, insurerId, updateInsurerDto, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, 'insurer', 'edit', insurerId);
            if (!editValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            const insurer = await this.insurerService.modifyInsurer(insurerId, updateInsurerDto, userId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.insurerUpdated, insurer));
        }
        catch (error) {
            if (error instanceof common_1.BadRequestException) {
                return res
                    .status(common_1.HttpStatus.BAD_REQUEST)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.BAD_REQUEST, error.message));
            }
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error.message || messages_1.errorMessages.failedToModifyInsurer));
        }
    }
    /** Delete an insurer by ID. */
    async deleteInsurer(insurerId, req, res) {
        try {
            const userId = parseInt(req?.headers?.userid);
            const editValidation = await this.scopeService.validateResourceScope(userId, 'insurer', 'edit', insurerId);
            if (!editValidation) {
                return res
                    .status(enum_1.statusCode.forbidden)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.FORBIDDEN, "Access denied: You do not have permission to edit this company."));
            }
            const result = await this.insurerService.deleteInsurer(insurerId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.insurerDeleted, result));
        }
        catch (error) {
            return (0, response_utils_1.handleErrorResponse)(error, res, messages_1.errorMessages.insurerNotFound, messages_1.infoMessages.forBidden, messages_1.errorMessages.failedToDeleteInsurer);
        }
    }
    /** Get contacts of an insurer by ID. */
    async getInsurerContacts(insurerId, res) {
        try {
            const contacts = await this.insurerService.getInsurerContacts(insurerId);
            return res
                .status(common_1.HttpStatus.OK)
                .json((0, response_utils_1.createResponse)(common_1.HttpStatus.OK, messages_1.successMessage.insurerContactsRetrieved, contacts));
        }
        catch (error) {
            if (error instanceof common_1.NotFoundException) {
                return res
                    .status(common_1.HttpStatus.NOT_FOUND)
                    .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.NOT_FOUND, error.message || messages_1.errorMessages.insurerContactsNotFound));
            }
            return res
                .status(common_1.HttpStatus.INTERNAL_SERVER_ERROR)
                .json((0, response_utils_1.createErrorResponse)(common_1.HttpStatus.INTERNAL_SERVER_ERROR, error.message || messages_1.errorMessages.failedToFetchInsurerContacts));
        }
    }
};
exports.InsurerController = InsurerController;
tslib_1.__decorate([
    (0, common_1.Post)(),
    (0, insurer_swagger_1.addInsurerSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_c = typeof Request !== "undefined" && Request) === "function" ? _c : Object, Object, typeof (_d = typeof create_insurer_dto_1.CreateInsurerDto !== "undefined" && create_insurer_dto_1.CreateInsurerDto) === "function" ? _d : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "addInsurer", null);
tslib_1.__decorate([
    (0, common_1.Get)(),
    (0, insurer_swagger_1.getAllInsurersSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_e = typeof get_all_insurers_dto_1.GetAllInsurersDto !== "undefined" && get_all_insurers_dto_1.GetAllInsurersDto) === "function" ? _e : Object, Object, typeof (_f = typeof Request !== "undefined" && Request) === "function" ? _f : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "getAllInsurers", null);
tslib_1.__decorate([
    (0, common_1.Get)("insurerList"),
    (0, insurer_swagger_1.getInsurerListSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Query)()),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__param(2, (0, common_1.Req)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Object, Object, typeof (_g = typeof Request !== "undefined" && Request) === "function" ? _g : Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "getInsurerList", null);
tslib_1.__decorate([
    (0, common_1.Get)("details/:id"),
    (0, insurer_swagger_1.getInsurerDetailsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("id")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_h = typeof Request !== "undefined" && Request) === "function" ? _h : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "getInsurerDetails", null);
tslib_1.__decorate([
    (0, common_1.Get)(":insurerId"),
    (0, insurer_swagger_1.getInsurerByIdSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("insurerId")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_j = typeof Request !== "undefined" && Request) === "function" ? _j : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "getInsurerById", null);
tslib_1.__decorate([
    (0, common_1.Put)(":insurerId"),
    (0, insurer_swagger_1.modifyInsurerSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Req)()),
    tslib_1.__param(1, (0, common_1.Param)("insurerId")),
    tslib_1.__param(2, (0, common_1.Body)()),
    tslib_1.__param(3, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [typeof (_k = typeof Request !== "undefined" && Request) === "function" ? _k : Object, Number, typeof (_l = typeof update_insurer_dto_1.UpdateInsurerDto !== "undefined" && update_insurer_dto_1.UpdateInsurerDto) === "function" ? _l : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "modifyInsurer", null);
tslib_1.__decorate([
    (0, common_1.Delete)(":insurerId"),
    (0, insurer_swagger_1.deleteInsurerSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("insurerId")),
    tslib_1.__param(1, (0, common_1.Req)()),
    tslib_1.__param(2, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, typeof (_m = typeof Request !== "undefined" && Request) === "function" ? _m : Object, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "deleteInsurer", null);
tslib_1.__decorate([
    (0, common_1.Get)(":insurerId/contacts"),
    (0, insurer_swagger_1.getInsurerContactsSwaggerMetadata)(),
    tslib_1.__param(0, (0, common_1.Param)("insurerId")),
    tslib_1.__param(1, (0, common_1.Res)()),
    tslib_1.__metadata("design:type", Function),
    tslib_1.__metadata("design:paramtypes", [Number, Object]),
    tslib_1.__metadata("design:returntype", Promise)
], InsurerController.prototype, "getInsurerContacts", null);
exports.InsurerController = InsurerController = tslib_1.__decorate([
    (0, common_1.Controller)("insurers"),
    tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof insurer_service_1.InsurerService !== "undefined" && insurer_service_1.InsurerService) === "function" ? _a : Object, typeof (_b = typeof scope_utils_1.ScopeService !== "undefined" && scope_utils_1.ScopeService) === "function" ? _b : Object])
], InsurerController);
